import { LED_COLORS } from './tournamentsMidi'

/* Eén bron voor "wat is de effectieve kleur van dit ding?".
   - Preset: eigen ui_color wint, anders LED-swatch, anders neutraal grijs.
   - Scherm: eigen ui_color wint, anders kind-default (participant vs admin). */

export const KIND_DEFAULT = {
  participant: '#B4FF39',
  admin:       '#00d9ff',
}

export function presetKleur(preset) {
  if (!preset) return '#94A3B8'
  if (preset.ui_color) return preset.ui_color
  return LED_COLORS[preset.led_color]?.swatch || '#94A3B8'
}

export function schermKleur(screen) {
  if (!screen) return '#94A3B8'
  if (screen.ui_color) return screen.ui_color
  return KIND_DEFAULT[screen.kind === 'admin' ? 'admin' : 'participant']
}

/* Een handzaam paletje voor de color-picker; gemixt uit onze tokens
   plus wat aparte tinten zodat groen naast lime niet meteen samenvalt. */
export const KLEUR_PALET = [
  '#B4FF39', '#c8ff2b', '#3adf3a', '#61E294', '#0E8F5C',
  '#00d9ff', '#337cff', '#5b4cff', '#8b3fff', '#c77bff',
  '#ff7ac8', '#ff2b8f', '#ff5a5a', '#ff9500', '#ffb57a',
  '#ffcf40', '#e4c265', '#fff8b0', '#ffffff', '#94a3b8',
]
